module.exports = __webpack_public_path__ + "assets/img/block-a0a396f7.png";